import { useTranslation } from 'react-i18next'
import { MarketplaceFlagSelect } from './MarketplaceFlagSelect'
import { ChannelAuditTabContent } from '../ChannelAuditTabContent'
import { ManualProductForm } from '../ManualProductForm'
import { MultiAsinInput } from '../MultiAsinInput'
import type { AnalysisMode } from './AnalysisModeCards'
import type { InputTab } from './useCampaignCreator'

interface CampaignCreatorFormProps {
  tab: InputTab
  inputValue: string
  setInputValue: (v: string) => void
  tld: string
  setTld: (t: string) => void
  batchMode: boolean
  setBatchMode: (v: boolean) => void
  asins: string[]
  setAsins: (a: string[]) => void
  celeryAvailable: boolean
  analysisMode: AnalysisMode
}

const noop = () => {}

export function CampaignCreatorForm({ tab, inputValue, setInputValue, tld, setTld, batchMode, setBatchMode, asins, setAsins, celeryAvailable, analysisMode }: CampaignCreatorFormProps) {
  const { t } = useTranslation()

  if (tab === 'asin') {
    return (
      <div className="space-y-3">
        {celeryAvailable && (
          <div className="flex items-center justify-between">
            <div>
              <span className="text-sm font-medium text-neutral-700 dark:text-neutral-300">
                {t('amazonListing.batchMode')}
              </span>
              <p className="text-xs text-neutral-500 dark:text-neutral-400">
                {t('amazonListing.batchModeHint')}
              </p>
            </div>
            <button type="button" role="switch" aria-checked={batchMode} onClick={() => setBatchMode(!batchMode)}
              className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors ${batchMode ? 'bg-primary-500' : 'bg-neutral-300 dark:bg-neutral-600'}`}>
              <span className={`pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform transition-transform ${batchMode ? 'translate-x-5' : 'translate-x-0'}`} />
            </button>
          </div>
        )}
        {batchMode ? (
          <>
            <MultiAsinInput asins={asins} setAsins={setAsins} />
            <MarketplaceFlagSelect value={tld} onChange={setTld} />
          </>
        ) : (
          <div className="flex gap-2">
            <input
              value={inputValue}
              onChange={e => setInputValue(e.target.value.toUpperCase())}
              placeholder={t('campaignCreator.asin.placeholder')}
              className="flex-1 h-[46px] rounded-[11px] border border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 px-3.5 font-mono text-sm outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20 transition-colors"
              aria-label={t('campaignCreator.asin.label')}
            />
            <MarketplaceFlagSelect value={tld} onChange={setTld} />
          </div>
        )}
      </div>
    )
  }

  if (tab === 'keyword') {
    return (
      <div className="flex gap-2">
        <input
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          placeholder={t('campaignCreator.keyword.placeholder')}
          className="flex-1 h-[46px] rounded-[11px] border border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 px-3.5 text-sm outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20 transition-colors"
          aria-label={t('campaignCreator.keyword.label')}
        />
        <MarketplaceFlagSelect value={tld} onChange={setTld} />
      </div>
    )
  }

  if (tab === 'produkt') {
    return <ChannelAuditTabContent onOpenChange={noop} />
  }

  if (tab === 'manuell') {
    return <ManualProductForm onOpenChange={noop} analysisMode={analysisMode} />
  }

  return null
}
